<template>
	<div>
		<ByDialog v-model="isShow" :closable="false">
			<template v-if="confirmCartItemsMessage.type === 'success'">
				<div class="text-center">{{ confirmCartItemsMessage.text[0] }}</div>
				<div class="text-center" style="margin-top: 10px">
					您的取餐號碼：{{ confirmCartItemsMessage.text[1] }}
				</div>
			</template>
			<template v-else-if="confirmCartItemsMessage.type === 'error'">
				<div class="text-center">{{ confirmCartItemsMessage.text[0] }}</div>
			</template>

			<template slot="dialog-footer">
				<div class="dialog-footer">
					<ByButton stl="main1" @click="handleCloseConfirmCartItems"
						>知道了
					</ByButton>
				</div>
			</template>
		</ByDialog>
	</div>
</template>

<script>
import {
	getOrderDetailList,
	handleAddOrderError as resolveAddOrderError,
} from '@/utils/order'
import ByDialog from '@/components/Dialog.vue'
import ByButton from '@/components/Button.vue'

export default {
	name: 'ByCompareCartConfirm',
	components: {
		ByButton,
		ByDialog,
	},
	data() {
		return {
			isShow: false,
			confirmCartItemsMessage: '',
		}
	},
	computed: {
		qrCodeHash() {
			return this.$storeManager.qrCodeHash
		},
		cart() {
			const cart = this.$store.getters['user/currCart'](this.qrCodeHash)
			return cart || []
		},
		isKiosk() {
			return this.$store.getters.isKiosk
		},
	},
	methods: {
		// 折扣清單取得失敗時 ready 會停在 false，此時畫面金額與贈品旗標都可能是
		// 過期的持久化資料 —— 送單前一律擋下並請 App 重新取一次（既有 watcher 負責重試）。
		// 放在本元件是因為訪客（Cart / Order）與 Kiosk（Store）三個送單入口都經過 confirm()
		ensureAutomaticDiscountReady() {
			if (this.$store.state.store.automaticDiscountListReady) return true
			this.$store.commit('store/SET_REFRESH_AUTOMATIC_DISCOUNT', true)
			this.$alert('折扣資料尚未更新完成，請稍後再試', 'danger')
			return false
		},
		// 引導語不分 Kiosk / 手機：關閉彈窗後的動線已由 handleCloseConfirmCartItems
		// 依身份處理（手機導回購物車、Kiosk 原頁即可見），文案再分岔只會讓
		// 窄螢幕彈窗多折一行
		showMenuStaleMessage(message) {
			this.isShow = true
			this.confirmCartItemsMessage = {
				type: 'error',
				text: [`${message}，請確認紅框`],
			}
		},
		async handleAddOrderError(error) {
			const result = await resolveAddOrderError(error, () =>
				this.$store.dispatch('user/compareCart'),
			)

			if (result.type === 'MENU_STALE') {
				this.showMenuStaleMessage(result.message)
			} else if (result.type === 'ERROR') {
				this.$alert(result.message, 'danger')
			}
		},
		handleCloseConfirmCartItems() {
			this.isShow = false
			if (this.cart.length === 0 && !this.isKiosk) {
				setTimeout(() => {
					this.$router.push(`/${this.$route.params.random}/Store`)
				}, 100)
				return
			}
			// 比對到異動（品項已標紅框）→ 引導回購物車處理；Kiosk 的購物車面板在原頁即可見
			if (
				this.confirmCartItemsMessage.type === 'error' &&
				!this.isKiosk &&
				this.$router.history.current.name !== 'Cart'
			) {
				setTimeout(() => {
					this.$router.push(`/${this.$route.params.random}/Cart`)
				}, 100)
			}
		},
		async confirm() {
			if (this.cart.length > 0) {
				if (!this.ensureAutomaticDiscountReady()) {
					return
				}

				const { message, status } =
					await this.$store.dispatch('user/compareCart')
				if (status === 1) {
					this.showMenuStaleMessage(message)
					return
				}

				if (this.isKiosk) {
					await this.goMeal()
					return
				}

				if (this.$router.history.current.name !== 'Order') {
					await this.$router.push(`/${this.qrCodeHash}/Order`)
				} else {
					return true
				}
			} else {
				this.$alert('請先選擇商品', 'danger')
			}
		},
		// 前台點餐 發送新增訂單api
		async goMeal() {
			// compareCart 期間可能收到折扣推播（ready 被打回 false），送單前再確認一次
			if (!this.ensureAutomaticDiscountReady()) {
				return
			}

			const { cart } = this
			const storeId = this.$storeManager.storeId
			this.$loading.show({
				message: '訂單送出中...',
				showResult: false,
			})
			try {
				const orderDetailList = getOrderDetailList(cart)

				const order = await this.$store.dispatch('socket/addOrder', {
					storeId,
					tableware: null,
					orderDetailList: orderDetailList,
					remark:
						this.$store.state.kioskOrderRemark !== ''
							? this.$store.state.kioskOrderRemark
							: undefined,
					takeTime: null,
					name: '',
					phone: '',
					discountPrice: 0,
					entertain: false,
					paid: false,
				})
				this.$store.state.kioskOrderRemark = ''
				this.$store.commit('user/SET_CART_ITEM', [])
				this.$store.commit('user/CLEAR_CURRENT_ORDER_AUTOMATIC_DISCOUNT')
				const res = (
					await this.$api.order.getOrderInfo({
						hashId: order.data.hashId,
					})
				).data

				this.$loading.done()
				this.confirmCartItemsMessage = {
					type: 'success',
					text: [
						'點餐成功！請記住您的取餐號碼並等待店家叫號取餐',
						res.takeNumber,
					],
				}
				this.isShow = true

				this.$store.state.kioskOrderRemark = ''
				sessionStorage.removeItem('category')
				sessionStorage.removeItem('xPosition')
				sessionStorage.removeItem('yPosition')
				this.$emit('onSubmit')
			} catch (err) {
				this.$loading.done()
				await this.handleAddOrderError(err)
			}
		},
	},
}
</script>

<style scoped lang="sass"></style>
